var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklistTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2800_10430)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2800_10430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6305 8.10326L10.429 14.3043C10.3873 14.3461 10.3378 14.3793 10.2832 14.402C10.2286 14.4247 10.1701 14.4363 10.1111 14.4363C10.052 14.4363 9.99348 14.4247 9.93892 14.402C9.88435 14.3793 9.83481 14.3461 9.79311 14.3043L7.39492 11.9038C7.35322 11.862 7.30367 11.8288 7.24911 11.8061C7.19455 11.7834 7.13605 11.7718 7.07697 11.7718C7.01789 11.7718 6.95939 11.7834 6.90483 11.8061C6.85026 11.8288 6.80071 11.862 6.75902 11.9038C6.71716 11.9455 6.68395 11.9951 6.66128 12.0496C6.63862 12.1042 6.62695 12.1627 6.62695 12.2218C6.62695 12.2809 6.63862 12.3394 6.66128 12.3939C6.68395 12.4485 6.71716 12.498 6.75902 12.5397L9.15811 14.9384C9.41119 15.191 9.75416 15.3329 10.1117 15.3329C10.4693 15.3329 10.8123 15.191 11.0654 14.9384L17.2664 8.73871C17.3082 8.69702 17.3413 8.6475 17.3639 8.59298C17.3866 8.53846 17.3982 8.48001 17.3982 8.42098C17.3982 8.36195 17.3866 8.30351 17.3639 8.24899C17.3413 8.19447 17.3082 8.14494 17.2664 8.10326C17.2247 8.0614 17.1751 8.02818 17.1206 8.00552C17.066 7.98286 17.0075 7.97119 16.9484 7.97119C16.8893 7.97119 16.8308 7.98286 16.7763 8.00552C16.7217 8.02818 16.6722 8.0614 16.6305 8.10326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.673146
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2800_10430",
    x1: -0.859091,
    y1: -1.04545,
    x2: 31.8636,
    y2: 28.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0237219,
    stopColor: "#FA96C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156443,
    stopColor: "#FF669B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904397,
    stopColor: "#BD8DE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2800_10430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7703,
    height: 10.7703,
    fill: "white",
    transform: "translate(6.61475 6.11475)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistTick);
export default __webpack_public_path__ + "static/media/ChecklistTick.b526cce03bf67fa84f8f01081aa9f217.svg";
export { ForwardRef as ReactComponent };